import { render, staticRenderFns } from "./AppShell.vue?vue&type=template&id=542d650e&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"
import style0 from "./AppShell.vue?vue&type=style&index=0&id=542d650e&prod&scoped=true&lang=css"
import style1 from "./AppShell.vue?vue&type=style&index=1&id=542d650e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d650e",
  null
  
)

export default component.exports